import { forwardRef } from 'react'
import {
  Root,
  Trigger,
  Portal,
  Overlay,
  Content as RadixContent,
  Title,
  Description,
  Close,
} from '@radix-ui/react-dialog'
import { Theme } from '@radix-ui/themes'

type ContentProps = React.ComponentPropsWithoutRef<typeof RadixContent>

// Radix Dialog portals to document.body, escaping the <Theme> wrapper at app
// root. Without that DOM ancestor the .radix-themes CSS variables and base
// styles never reach Themes components rendered inside the dialog (Select,
// TextField, etc. fall back to native browser styling). Re-establish the scope
// by merging Theme's class+data attrs onto the Content element via asChild.
const Content = forwardRef<HTMLDivElement, ContentProps>((props, ref) => (
  <Theme asChild>
    <RadixContent ref={ref} {...props} />
  </Theme>
))
Content.displayName = 'Dialog.Content'

export { Root, Trigger, Portal, Overlay, Content, Title, Description, Close }
